<template>
  <div id="app" class="app">
    <!--<conf-popup />-->
    <!--<inform-msgs />-->
  	<!--<app-header />-->
    <router-view />
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader'
import ConfPopup from '@/components/common/ConfPopup'
import InformMsg from '@/components/common/InfomMsg'
import api from './api'

export default {
  name: 'app',
  data () {
    return {
      industry: null,
      isLocalHost: false
    }
  },
  components: {
    AppHeader,
    ConfPopup,
    InformMsg
  },
  mounted () {
    this.industry = localStorage.getItem('userIndustry')
    this.isLocalHost = location.hostname === 'localhost'
    if (this.industry) {
      let userData = localStorage.getItem('userData')
      let app = document.getElementById('app')
      if (userData) {
        userData = JSON.parse(userData)
        if (userData['role'] !== 'gm' && app) {
          app.setAttribute('data-industry', this.industry)
        }
      } else {
        app.setAttribute('data-industry', this.industry)
      }
    }
  },
  beforeMount () {
    let element = document.createElement('link')
    element.setAttribute('rel', 'stylesheet')
    element.setAttribute('type', 'text/css')
    element.setAttribute('href', api.serverURL + '/assets/css/industries.css')
    document.getElementsByTagName('head')[0].appendChild(element)
  }
}
</script>

<style src="@/assets/scss/app.scss" lang="scss" />
<!--<style src="../../clear-cms-backend/web/assets/scss/industries.scss" lang="scss" scoped />-->
<!--<style src="../html/web/assets/scss/industries.scss" lang="scss" scoped />-->



// WEBPACK FOOTER //
// App.vue?1fcf149a